import { createEvent, createStore } from 'effector'
import { z } from 'zod'

import { UserMuteSchema } from './mute'

export const userLogout = createEvent()

export const $userInfo = createStore<UserInfo | null>(null).reset(userLogout)
export const $userId = $userInfo.map((userInfo) => userInfo?.user_id ?? null)

// UserInfo

export const UserInfoSchema = z.object({
    token: z.string(),
    user_id: z.string(),
    role: z.string().optional(), // admin | moderator
    mute: UserMuteSchema.optional(),
})

export type UserInfo = z.infer<typeof UserInfoSchema>

export function isPrivilegedUser(userInfo: UserInfo | null): boolean {
    return isPrivilegedRole(userInfo?.role)
}

export function isPrivilegedRole(role: string | undefined): boolean {
    return role === 'admin' || role === 'moderator'
}
